/**
 * シングルモードのクリア進捗を localStorage に永続化する薄いラッパー。
 *
 * 保存形式: キー 'palisade.stageProgress' に JSON `{ cleared: ['stage-01', ...] }`。
 * プライベートモードや storage 例外でも UI を壊さないよう、読み書きは全て
 * try/catch で握りつぶし、失敗時は「クリアなし」相当にフォールバックする
 * （進捗は残らないがプレイは続行できる）。
 *
 * 純粋なデータ層（DOM / three.js 非依存）。localStorage が無い環境（node の
 * テスト等）では storageOf() が null を返し、全 API が安全な既定値を返す。
 */

const STORAGE_KEY = 'palisade.stageProgress';

function storageOf() {
  try {
    return typeof localStorage !== 'undefined' ? localStorage : null;
  } catch {
    return null; // アクセス自体が SecurityError を投げる環境がある
  }
}

/** クリア済みステージ id の配列を読む。壊れていれば空配列。 */
export function loadStageProgress() {
  const store = storageOf();
  if (!store) return [];
  try {
    const raw = store.getItem(STORAGE_KEY);
    if (!raw) return [];
    const data = JSON.parse(raw);
    if (data && Array.isArray(data.cleared)) {
      return data.cleared.filter((id) => typeof id === 'string');
    }
  } catch {
    // 破損 JSON 等: クリアなし扱い
  }
  return [];
}

/** id がクリア済みか。 */
export function isStageCleared(id) {
  return loadStageProgress().includes(id);
}

/**
 * id をクリア済みとして記録する（重複は無視）。永続化できなくても例外は
 * 投げず、更新後の配列を返す（呼び出し側が即座にチェック表示へ使える）。
 */
export function saveStageCleared(id) {
  const cleared = loadStageProgress();
  if (!cleared.includes(id)) cleared.push(id);
  const store = storageOf();
  if (store) {
    try {
      store.setItem(STORAGE_KEY, JSON.stringify({ cleared }));
    } catch {
      // 永続化できなくても進行自体は続行
    }
  }
  return cleared;
}
